<template>
    <section>
        <div class="row d-flex justify-content-center m-0 p-0 wow fadeIn" id="results">
            <div class="info-bar p-2 py-5 w-100 ">
                <div class="col text-center  pt-2">
                    <h2>
                        <strong>{{ $t('Available vehicles') }}</strong> {{ $t('on selected period') }}
                    </h2>
                    <h5>
                        {{ result_form.start_date }}&nbsp;– {{ result_form.end_date }}
                    </h5>
                </div>
            </div>
        </div>
        <div class="container mt-0 pt-0">
            <div class="row mt-3">
                <div class="col p-0">
                    <div id="accordion">
                        <div class="card accordion-list shadow-none" v-for="(vehicle, i) in results" :key="i">
                            <div class="card-header">
                                <div class="row">
                                    <div class="col-lg-3 col-md-6">
                                        <a class="card-link">
                                            <template v-if="vehicle.imgs.length">
                                                <vue-carousel :data="getVehicleImgs(vehicle.imgs)" :controls="false" indicator-type="disc" :indicators="vehicle.imgs.length === 1 ? false : true"/>
                                            </template>
                                            <div v-else class="card-image rounded z-depth-1 w-75">
                                                <div class="view car-img pointer" />
                                            </div>
                                        </a>
                                    </div>
                                    <div class="col-lg-6 col-md-6 list-mark">
                                        <div class="row">
                                            <h6 class="dark-grey-text font-weight-normal">
                                                <a class="card-link" data-toggle="collapse" :href="`#vehicle_${i}`">
                                                    {{ vehicle.make.name }} {{ vehicle.model.name }} <app-vehicle-no :slug="vehicle.slug"/>
                                                </a>
                                            </h6>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-4 col-md-4 col-sm-12 pl-0">
                                                <p class="dark-grey-text p-300-sm">
                                                    {{ vehicle.user_year }}
                                                    <br>
                                                    {{ $t(vehicle.fuel.name) }}
                                                    <br>
                                                    {{ $t(vehicle.transmission.name) }}
                                                    <br>
                                                    {{ vehicle.body_type[locale] }}
                                                </p>
                                            </div>
                                            <div class="col-lg-8 col-md-8 col-sm-12 pl-0">
                                                <div class="card">
                                                    <div class="table-responsive">
                                                        <table class="table table-bordered table-sm sm-price-table mb-0">
                                                            <thead>
                                                                <tr class="table-hinnad text-center">
                                                                    <th class="sticky-top" scope="col" v-for="(price, jn) in vehicle.prices" :key="jn">
                                                                        {{ price.range.min === 0 ? price.range.min + 1 : price.range.min }}-{{ price.range.max | valueOrDots }} {{ $t('days') }}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr class="text-center">
                                                                    <th v-for="(price, j) in vehicle.prices" :key="j">
                                                                        <template v-if="price.discount_price && discountPricesExpired(vehicle)">
                                                                            <span style="text-decoration: line-through">
                                                                                {{ price.price / 100 }} <br> <small>EUR/{{ $t('day') }}</small><br>
                                                                            </span>
                                                                            <span class="text-danger">
                                                                                {{ price.discount_price / 100 }} <br> <small>EUR/{{ $t('day') }}</small>
                                                                            </span>
                                                                        </template>
                                                                        <template v-else>
                                                                            {{ price.price / 100 }} <br> <small>EUR/{{ $t('day') }}</small>
                                                                        </template>
                                                                    </th>
                                                                </tr>
                                                            </tbody>
                                                            <tfoot v-if="hasDiscountDates(vehicle)">
                                                                <tr>
                                                                    <th :colspan="vehicle.prices.length" class="text-danger pt-0">
                                                                        <small>{{ $t('Discount rates are valid from') }} {{ vehicle.discount_start_at | formatDate }} - {{ vehicle.discount_end_at | formatDate }}</small>
                                                                    </th>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                                <app-overlapping :vehicle="vehicle"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-6">
                                        <div class="d-flex justify-content-center align-items-start">
                                            <router-link :to="{name: 'pub.booking', params: { vehicle_slug: vehicle.slug }, query: {start_date: result_form.start_date, end_date: result_form.end_date}}"
                                                         class="btn btn-outline-autorent w-100">
                                                {{ $t('Book now') }}
                                            </router-link>
                                        </div>
                                        <br />
                                        <div class="d-flex justify-content-center align-items-end">
                                            <p class="dark-grey-text p-300">
                                                <a class="card-link" data-toggle="collapse" :href="`#vehicle_${i}`">
                                                    {{ $t('Check specifics') }}
                                                    <fa-icon :icon="['fas', 'angle-down']" pull="right" class="pl-1 mt-1"/>
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :id="`vehicle_${i}`" class="collapse" data-parent="#accordion">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-lg-3 col-md-6">
                                            <div class="table-responsive text-nowrap ml-0">
                                                <table class="table table-borderless">
                                                    <tbody>
                                                        <tr>
                                                            <th>
                                                                <p class="dark-grey-text p-300-sm">
                                                                    {{ $t('Year') }} <br>
                                                                    {{ $t('Engine') }} <br>
                                                                    {{ $t('Color') }} <br>
                                                                    {{ $t('Type') }}
                                                                </p>
                                                            </th>
                                                            <th>
                                                                <p class="dark-grey-text p-400-sm">
                                                                    {{ vehicle.user_year }} <br>
                                                                    {{ vehicle.engine }} <br>
                                                                    {{ vehicle.color[locale] }} <br>
                                                                    {{ $t(vehicle.type.name) }}
                                                                </p>
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="col-lg-3 col-md-6 ">
                                            <p class="dark-grey-text p-400 pt-3">{{ $t('Equipment') }}</p>
                                            <p class="dark-grey-text p-300-xs">{{ vehicle.equipment[locale] }}</p>
                                        </div>
                                        <div class="col-lg-3 col-md-6">
                                            <app-booking-calendar :id="vehicle.id"
                                                                  :dates_chosen="[result_form.start_date, result_form.end_date]"
                                                                  :booked_dates="vehicle.booked_dates"
                                                                  :unconfirmed_dates="vehicle.unconfirmed_dates"/>
                                        </div>
                                        <div class="col-lg-3 col-md-6 m-auto ">
                                            <div class="marker d-flex justify-content-center p-0">
                                                <ul class="list-group">
                                                    <li class="list-group-item m-0 p-0">
                                                        <div class="md-v-line">
                                                            <p class="dark-grey-text p-300-xs mb-1">
                                                                <img height="15px" src="~@assets/img/svg/kalender/marker.svg" alt=""/> {{ $t('Available') }}
                                                            </p>
                                                        </div>
                                                    </li>
                                                    <li class="list-group-item m-0 p-0">
                                                        <div class="md-v-line">
                                                            <p class="dark-grey-text p-300-xs mb-1">
                                                                <img height="15px" src="~@assets/img/svg/kalender/marker_info.svg" alt=""/> {{ $t('Unconfirmed') }}
                                                            </p>
                                                        </div>
                                                    </li>
                                                    <li class="list-group-item m-0 p-0">
                                                        <div class="md-v-line">
                                                            <p class="dark-grey-text p-300-xs mb-1">
                                                                <img height="15px" src="~@assets/img/svg/kalender/marker_secondary.svg" alt=""/> {{ $t('Booked') }}
                                                            </p>
                                                        </div>
                                                    </li>
                                                    <li class="list-group-item m-0 p-0">
                                                        <div class="md-v-line">
                                                            <p class="dark-grey-text p-300-xs mb-1">
                                                                <img height="15px" src="~@assets/img/svg/kalender/marker_primary.svg" alt=""/> {{ $t('My dates') }}
                                                            </p>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <hr />
                                            <br />
                                            <p class="dark-grey-text p-300-sm text-center">
                                                <a class="card-link" role="button" @click="$emit('resetFrom')">
                                                    {{ $t('Change period') }}
                                                </a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import clonedeep from 'lodash/cloneDeep';
import { validityPeriod } from '@services/helper.service';
import AppBookingCalendar from '@components/layout/public/BookingCalendar';
import moment from 'moment';

export default {
    name: 'AppSearchResults',
    props: {
        search_form: Object,
        results: Array
    },
    data() {
        return {
            result_form: clonedeep(this.search_form)
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        hasDiscountDates(vehicle) {
            let hasDiscountPrices = false;
            vehicle.prices.map(price => {
                if (price.discount_price) {
                    hasDiscountPrices = true;
                }
            });

            let showDiscountDates = false;
            if (hasDiscountPrices && vehicle.discount_start_at && vehicle.discount_end_at && moment(vehicle.discount_end_at).isAfter(moment())) {
                showDiscountDates = true;
            }

            return showDiscountDates;
        },
        discountPricesExpired(vehicle) {
            let isExpired = false;
            if (vehicle.discount_end_at == null) {
                return true;
            }
            if (moment(vehicle.discount_end_at).isAfter(moment())) {
                isExpired = true;
            }

            return isExpired;
        },
        getVehicleImgs(imgs) {
            return imgs.map(i => `<img src="${this.envUrl}/vehicles/${i.dbname}" height="auto" class="img-thumbnail rounded z-depth-1 w-75"/>`);
        },
        validityPeriod(pricelist) {
            return validityPeriod(pricelist);
        }
    },
    components: {
        AppBookingCalendar
    }
};
</script>
<style>
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent !important;
}
.theme--light.v-btn {
    outline: none!important;
}
.theme--light.v-btn:before {
    background-color: transparent !important;
}
</style>
